/* eslint-disable */
/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 **/

import { createApp } from 'vue';

import '@seedkit/assets/themes/default/index.css';
// import '@seedkit/vue/styles';
import createSeedkitApp from './main.js';


import initApplication from 'app/src/app/init';


import createdApplicationHook from 'app/src/app/created';
import { useAppStore } from '@seedkit/vue/stores';





async function start ({
  seedkit,
  app,
  router,
  store,
}) {
  // app.use(createSeedKitUiLib({ core: seedkit }));
  app.use(store);
  seedkit.installPlugins();
  
  await createdApplicationHook(seedkit);
  
  
  seedkit.init(useAppStore()).then(() => {
    
    initApplication(seedkit);
    
    app.use(router);
    
    seedkit.modules.installedModules.forEach((module) => {
      if (typeof module.mounted === 'function') {
        module.mounted();
      }
    });
    app.mount('#seedkit');
  });
}

createSeedkitApp(createApp).then(start);

